'use client';
import { getTheme, setTheme } from '@/services/StorageService';
import React, { createContext, useContext, useEffect, useState } from 'react';

export enum EThemeType {
  DARK = 'dark',
  LIGHT = 'light',
}

type TThemeContextType = {
  isDarkMode: boolean;
  toggleTheme: () => void;
  setIsDarkMode: (mode: boolean) => void;
};

const ThemeContext = createContext<TThemeContextType | null>(null);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(getTheme() === EThemeType.DARK ? true : false);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add(EThemeType.DARK);
      setTheme(EThemeType.DARK);
    } else {
      document.documentElement.classList.remove(EThemeType.DARK);
      setTheme(EThemeType.LIGHT);
    }
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode(prev => !prev);

  return <ThemeContext.Provider value={{ isDarkMode, setIsDarkMode, toggleTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
